import React            from 'react';
import ReactButton      from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(ReactButton)(({ theme }) => ({
	'&.MuiButton-containedPrimary': {
		background: theme.palette.primary.gradientInverted,
		color: theme.palette.text.primary,
	},
	'&.Mui-disabled': {
		color: 'rgba(255, 255, 255, 0.3)',
		boxShadow: 'none',
		background: 'rgba(255, 255, 255, 0.12)',
	}
}));

const Button = React.forwardRef(({ loading, children, ...rest }, ref) => {
	if (loading) {
		rest.disabled = true;
		rest.endIcon = <CircularProgress thickness={2} size={16}/>;
	}

	return (
		<StyledButton {...rest} ref={ref}>
			{children}
		</StyledButton>
	);
});

export default Button;
